export default function layoutDataSelector(func) {
  let { adminReducer, loadingReducer } = func((state) => state);
  return { ...adminReducer, ...loadingReducer };
}
